{
  "access-denied-user": "The user does not have web access permission",
  "activation": "Activation",
  "code": "Code",
  "code-sent": "Code sent",
  "contact": "Contact",
  "enter": "Enter",
  "error-text": "Error",
  "mail": "Email",
  "new-version-available": "New version available",
  "password": "Password",
  "resend-wait": "Wait {{seconds}}s to resend",
  "server-apologies": "Sorry for the inconvenience",
  "server-maintenance": "Server under maintenance",
  "translation-load-error": "Error loading translations",
  "user": "User",
  "user-or-password-incorrect": "Incorrect user or password",
  "wait": "Please wait"
}